export const ADD = 'entities/donationMatchingRule/ADD';
export const ADD_MULTIPLE = 'entities/donationMatchingRule/ADD_MULTIPLE';
export const UPDATE = 'entities/donationMatchingRule/UPDATE';
export const REMOVE = 'entities/donationMatchingRule/REMOVE';
